/**
* Mode d'affichage d'une fiche objet * 
*******************************/
enum ObjectDisplayingModeEnum {
	/** Nouvel objet */
	New = 0,
	/** Lecture uniquement */
	Read = 1,
	/** Modification de la fiche */
	Write = 2
}

export default ObjectDisplayingModeEnum;